export const sendCustomerDataQueryHealth = `mutation Trigger($productType: ProductType!, $email: String!, $firstName: String!) {
  triggerEvent(input: { alert: {
    productType: $productType
    email: $email,
    firstName: $firstName
  }}) {
    success
    errors {
      code
      message
    }
  }
}`;
